module.exports = __webpack_public_path__ + "img/icon_service_on.c3d33e91.svg";